module.exports = __webpack_public_path__ + "static/media/logo-voala-simples.93928acb.svg";